import { Download } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eHoaDonDienTuActionsObj } from "../../action-types/hoa-don/IHoaDonDienTuAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const hoaDonDienTuActions = {
  ...generateActions(eHoaDonDienTuActionsObj, "HOA_DON_DIEN_TU"),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_MULTIPLE_SUCCESS",
    // Payload nay là DANH SÁCH trạng thái từng phiếu, không phải câu thông báo -> tự đếm rồi báo.
    (ds: any) => {
      const so_dong = Array.isArray(ds) ? ds.length : 0;
      const so_da_xuat = Array.isArray(ds)
        ? ds.filter((x: any) => x?.is_success).length
        : 0;
      NotifyHelper.Success(
        so_dong
          ? `Đã phát hành ${so_da_xuat}/${so_dong} hóa đơn`
          : "Phát hành thành công",
      );
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_MULTIPLE_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "HUY_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "HUY_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "DIEU_CHINH_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "DIEU_CHINH_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "VIEW_DETAIL_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_HOA_DON_SUCCESS",
    (payload: { data: string; ten_file?: string }) => {
      // Tên file theo cấu trúc {so_hoa_don}_{ho_ten}; bỏ ký tự không hợp lệ cho tên file.
      const safe = (payload.ten_file || "hoa_don_dien_tu")
        .replace(/[\\/:*?"<>|]+/g, "_")
        .trim();
      Download.Pdf(payload.data, `${safe}.pdf`);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_HOA_DON_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PREVIEW_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_NHAP_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_NHAP_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "SYNC_STATUS_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m ?? "Thành công");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "SYNC_STATUS_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_CHON_XUAT_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_CHON_XUAT_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
